import { Job } from "../../../../../models/job";
import { Customer } from "../../../../../models/customer";

export interface SearchAttribute {
  attribute: string;
  values: string[];
}

interface OrderToSearch extends Job {
  [x: string]: any;
}

export const filterOrders = (orders: Array<any>, searchAttributes: SearchAttribute[]) => {
  return searchAttributes.reduce((filteredOrders, searchAttribute) => {
    const { attribute, values } = searchAttribute;

    if (attribute.includes(".")) {
      const [objectName, objectProperty] = attribute.split(".");

      return filteredOrders.filter((order: OrderToSearch) => {
        return values.some((value) => {
          const nestedObject = order?.[objectName];

          return String(nestedObject?.[objectProperty])
            ?.toLowerCase()
            .includes(value.toLowerCase());
        });
      });
    }

    return filteredOrders.filter((order: OrderToSearch) => {
      return values.some((value) =>
        String(order[attribute])?.toLowerCase().includes(value.toLowerCase())
      );
    });
  }, orders);
};
